<template>
	<div class="center" v-title="'齐齐直播'">
		<navtop></navtop>
		<div class="userInfo">
			<div class="pic">
				<img v-bind:src="userImg||'../../../static/zhubo.jpg'" />
			</div>
			<p class="userName">
				<a v-if="!fixednick">{{baseInfo.nick!=='undefined'?baseInfo.nick.slice(0,8):'齐齐牛人'}}</a>
				
				<a v-if="fixednick">
					<input class="fixednick-inp" type="text" v-bind:placeholder="baseInfo.nick!=='undefined'?baseInfo.nick.slice(0,6):''" v-model="uNick" autofocus="autofocus" />
					<input type="button" value="保存" v-on:click="subNick" v-bind:disabled="saveNick"/>
					<input type="button" value="取消" v-on:click="cancelSubNick"/>
				</a>
				<i  class="edit" v-on:click="fixednick = !fixednick" v-if="!fixednick"></i>
			</p>
			<div class="uLabel">
				<img v-bind:src="leval?('https://static.qxiu.com/h5/img/static/nobility/'+(leval.nobility)+'.png'):''" />
				<p class="userId">ID : {{baseInfo.uid}}</p>
			</div>
		</div>
		<ul class="funcList">
			<li class="zhye" v-if="showYe">
				<img class="icon" src="../../img/dating/icon-cash.png"/>
				<div class="wrap">
					<span>余额:</span>
					<!--<i class="iconfont">&#xe883;</i>-->
					<a v-on:click="toCharge" >充值</a>
					<span class="ye">{{qiqidou}}</span>
				</div>
			</li>
			<li class="mycare" v-on:click="toMycare">
				<img class="icon" src="../../img/dating/icon-care.png"/>
				<div class="wrap">
					<span>我关注的</span>
				</div>
			</li>
			<li class="bindPhone" v-on:click="toBindPhone" v-if="isxiaoxiong">
				<img class="icon" src="../../img/dating/icon-phone.png"/>
				<div class="wrap">
					<span>绑定手机号</span>
				</div>
			</li>
			<li class="jwdj">
				<img class="icon" src="../../img/dating/icon-level.png"/>
				<div class="wrap">
					<span class="level">等级</span>
					<p><img v-bind:src="leval?('https://static.qxiu.com/h5/img/static/nobility/'+(leval.nobility)+'.png'):''" /></p>
					<div class="nobWrap">
						<b>{{curScore}}/{{totalScore}}</b>
						<i v-bind:style="'width: '+curScore/totalScore*6.4+'rem;'"></i>
					</div>
					<p><img v-bind:src="leval?('https://static.qxiu.com/h5/img/static/nobility/'+(leval.nobility+1)+'.png'):''"  v-if="leval.nobility!=28"/></p>
				</div>
			</li>
			<li v-on:click="kefuQQ=true">
				<img class="icon" src="../../img/dating/icon-connect.png"/>
				<div class="wrap">
					<span class="bgKf">联系客服</span>
				</div>
			</li>
			<li class="authCode-item">
				<div class="authCode-wrap">
					<!-- 登陆码标签 -->
					<span class="authCode-label">登陆码</span>
					<!-- 滑动容器（核心） -->
					<div class="authCode-scroll">
						<span class="authCode-text">{{ authCode }}</span>
					</div>
				</div>
			</li>
			<li class="logout" v-if="isHideLogout&&!isYouxi">
				<img class="icon" src="../../img/dating/icon-logout.png"/>
				<div class="wrap">
					<a href="javascript:void(0)" v-on:click="logout" class="logout">退出账号</a>
				</div>
			</li>
		</ul>
		<div class="pop" v-if="kefuQQ">
			<p>请联系官方客服QQ:</p>
			<p>8007777777</p>
			<button v-on:click="kefuQQ=false">确定</button>
			<i v-on:click="kefuQQ=false">x</i>
		</div>
		<div class="pop" v-if="logoutTips">
			<p>退出登录</p>
			<button v-on:click="confirmLogout">确定</button>
			<i v-on:click="logoutTips=false">x</i>
		</div>
		<div class="pop" v-if="nickTips">
			<p>{{nickTipsCon}}</p>
			<button v-on:click="nickTips=false">确定</button>
			<i v-on:click="nickTips=false">x</i>
		</div>
		<!--<navbottom v-bind:index="navBott"></navbottom>-->
	</div>
</template>

<script>
	import { mapState } from 'vuex'
	import nobility from '../../libs/nobility'
	import cookie from '../../libs/cookie'
	import jsCookies from 'js-cookie';
	import passPort from '../../libs/passport'
	import navtop from '../dating/navTop'
	import navbottom from '../dating/navBottom'
	export default {
		name: 'center',
		data() {
			return {
				navBott: 2,
				qiqidou: 0,
				leval: '',
				fixednick: false,
				uNick: '',
				baseInfo: {
					nick: cookie.get('nick'),
					uid: cookie.get('uid'),
				},
				kefuQQ:false,
				saveNick:false,
				logoutTips:false,
				nickTipsCon:'',
				nickTips:false,
				showYe: true
			}
		},
		components: {
			navtop,
			navbottom,
		},
		computed: {
			userImg(){
				if(cookie.get('photo') && cookie.get('photo') != 'null' &&cookie.get('photo').indexOf('static.qxiu.com')==-1){
					if(cookie.get('photo').slice(0,1)=='"'){
						return 'https://qiqi-resource-v6.qxiu.com'+cookie.get('photo').slice(1,-1).slice(29)
					}else{
						return 'https://qiqi-resource-v6.qxiu.com'+cookie.get('photo').slice(29)
					}
				}else{
					if(this.isxiaoxiong){
						return 'https://static.qxiu.com/h5/static/xiaoxiong.png'
					}else{
						return 'https://static.qxiu.com/h5/static/img/app.png'
					}
				}
			},
			curScore(){
				if(nobility.levelObj[this.leval.nobility]){
					return (this.leval.score-nobility.levelObj[this.leval.nobility].get_score)
				}
			},
			totalScore() {
				let _totalScore = nobility.levelObj[this.leval.nobility]
				if(_totalScore) {
					return _totalScore.totalScore
				}
			},
			isHideLogout(){
				var channel=cookie.get('channelid');
				return ((channel != 54)&&(channel != 55)&&(channel != 10102))
			},
			isxiaoxiong(){
				return cookie.get('isxiaoxiong')=='true'
			},
			...mapState(
				['isYouxi']
			),
			authCode() {
				return jsCookies.get('authCode') || '未获取到authCode';
			}
		},
		mounted() {
			if(!passPort.isLogin()){
				this.$store.commit('getCurview', '')
				location.hash="/"
			}
			var _this = this
			
			var u = navigator.userAgent,
			isGooglePlay = !!u.match(/_GM_/); //googlePlay手Q终端
			if(isGooglePlay){
				this.showYe = false;
			}
			$.ajax({
				type: "get",
				url: "https://api-live.qxiu.com/webProxy/cgi/webQiQiDouQuery?userId="+cookie.get('uid')+'&meck='+cookie.get('mcheck'),
				async: true,
				dataType: "jsonp",
				success: function(res) {
					_this.qiqidou = res.result.qiqidou
				}
			});
			$.ajax({
				type: "get",
				url: "https://account.qxiu.com/nobility/getNobilityAndScoreByUid?uid="+cookie.get('uid')+'&meck='+cookie.get('mcheck'),
				async: true,
				dataType: "jsonp",
				jsonp: "callbackname",
				success: function(res) {
					if(res && res.code == 0) {
						_this.leval = res.rs
					}
				}
			});
		},
		methods: {
			subNick() {
				if(this.uNick) {
					if(this.uNick.length>8){
						this.nickTips=true
						this.nickTipsCon="昵称不能超过8个汉字"
						return false
					}else if(this.uNick.indexOf(" ")!=-1){
						this.nickTips=true
						this.nickTipsCon="昵称不能包含空格"
						return false
					}
					let _this = this
					_this.uNick= _this.uNick.length>8?_this.uNick.slice(0,8):_this.uNick
					$.ajax({
						type: "get",
						url: "https://api-live.qxiu.com/webProxy/cgi/webUpUserInfo",
						dataType: "jsonp",
						data: {
							userId: _this.baseInfo.uid,
							nickname:_this.uNick
						},
						async: true,
						success: function(res) {
							if(res.result.state == 0) {
								_this.fixednick = !_this.fixednick
								cookie.set('nick', _this.uNick, {
									domain: 'qxiu.com',
									encode: true
								})
								_this.baseInfo.nick=cookie.get('nick')
							}
						}
					})
				}else{
					this.nickTips=true
					this.nickTipsCon="昵称不能为空"
				}
			},
			cancelSubNick(){
				this.fixednick=false
				this.uNick=''
			},
			logout(){
				this.logoutTips=true
			},
			confirmLogout(){
				this.logoutTips=false
				cookie.remove('uid',{domain:'qxiu.com'})
				cookie.remove('accessToken',{domain:'qxiu.com'})
				cookie.remove('openid',{domain:'qxiu.com'})
				cookie.remove('webToken',{domain:'qxiu.com'})
				cookie.remove('refreshToken',{domain:'qxiu.com'})
				cookie.remove('mcheck',{domain:'qxiu.com'})
				cookie.remove('pgv_pvi',{domain:'qxiu.com'})
				cookie.remove('closedownLoad',{domain:'qxiu.com'})
				cookie.remove('tempid',{domain:'qxiu.com'})
				cookie.remove('tempmcheck',{domain:'qxiu.com'})
				cookie.remove('wxopenid',{domain:'qxiu.com'})
				cookie.remove('bindPhone',{domain:'qxiu.com'})
				location.hash='/'
			},
			toCharge(){
				if((!cookie.get('wxopenid'))&&this.isWeixin()){
//					location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxbdf212b5475d03c2&redirect_uri=http%3a%2f%2flogin.m.qxiu.com%2fcgi%2flogin%2fcallback%3floginType%3dwechatGZH%26target%3dweblive%26loginDataTransfer%3dparam%26toUrl%3d"+ location.protocol.slice(0,-1) +"%3a%2f%2fh5.qxiu.com%2F%23%2Frecharge&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect"
					location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxbdf212b5475d03c2&redirect_uri=http%3a%2f%2flogin.m.qxiu.com%2fcgi%2flogin%2fcallback%3floginType%3dwechatGZH%26target%3dweblive%26loginDataTransfer%3dparam%26toUrl%3dhttps%3a%2f%2fh5.qxiu.com%2F%23%2Frecharge&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect"
				}else{
					location.hash="#/recharge"
				}
			},
			toMycare(){
				location.hash="#/care"
			},
			toBindPhone(){
				location.hash="#/bindPhone"
			},
			isWeixin() {
				var ua = window.navigator.userAgent.toLowerCase();
				if(ua.match(/MicroMessenger/i) == 'micromessenger') {
					return true;
				} else {
					return false;
				}
			}
		},
		watch:{
			uNick(){
				if(!this.uNick){
					this.saveNick=true
				}else{
					this.saveNick=false
				}
			}
		}
	}
</script>

<style scoped>
	
	.userInfo {
		position: relative;
		margin-top: 2.2rem;
		padding:  0.6rem 0.6rem 0.68rem;
		background: #fff;
	}
	
	.pic {
		width: 3.6rem;
		height: 3.6rem;
		margin: 0 auto;
		position: relative;
		border-radius: 50%;
		box-shadow: 0 0 15px #F3E8EC;
		text-align: center;
	}
	
	.pic img {
		width: 3.6rem;
		height: 3.6rem;
		border-radius: 50%;
	}
	
	.userName {
		margin: 0.3rem 0;
		font-size: 0.68rem;
		text-align: center;
	}
	.userName>a{
		font-size: 0.8rem;
		font-weight: 600;
	}
	
	.userName>img {
		height: 0.72rem;
		vertical-align: middle;
		margin-right: 0.2rem;
	}
	
	.userName> .edit{
		position: absolute;
		top: 2.28rem;
		right: 1.5rem;
		width: 0.34rem;
		height: 0.68rem;
		background: url(../../img/dating/right.png) no-repeat;
		background-size: contain;
	}
	
	.userName input[type=text] {
		-webkit-appearance: none;
		border-radius: 0;
		width: 6.6rem;
		border: none;
		border-bottom: 1px solid #ccc;
		margin: 0 0.2rem;
		font-size: 0.66rem;
		outline: none;
		text-align: center;
	}
	
	.uLabel{
		text-align: center;
	}
	.uLabel img{
		height: 0.56rem;
		vertical-align: middle;
	}
	.userId {
		height: 0.56rem;
		display: inline-block;
		background: #B5C1CC;
		font-size: 0.44rem;
		line-height: 0.56rem;
		color: #fff;
		padding: 0 0.32rem;
		border-radius: 0.28rem;
	}
	.funcList{
		min-height: 13rem;
		margin-top: 0.4rem;
		background: #fff;
	}
	.funcList li {
		height: 2rem;
		padding-right: 0.4rem;
	}
	
	.funcList li:last-child {
		border-bottom: none;
	}
	.funcList li .wrap{
		float: left;
		width: 12.6rem;
		height: 2rem;
		border-bottom: 1px solid #EFEFEF;
	}
	.funcList li span {
		line-height: 2rem;
		font-size: 0.56rem;
		vertical-align: middle;
	}
	
	.funcList li .icon{
		float: left;
		width: 0.72rem;
		height: 0.72rem;
		margin: 0.6rem 0.56rem 0 0.72rem;
	}
	
	.zhye i,
	.zhye a {
		float: right;
		line-height: 1.88rem;
		font-size: 0.56rem;
	}
	
	.zhye a {
		width: 2.4rem;
		height: 1.2rem;
		background: #8D49E5;
		line-height: 1.2rem;
		text-align: center;
		border-radius: 0.6rem;
		color: #fff;
		font-size: 0.52rem;
		margin:0.4rem 0.1rem 0 0;
	}
	
	.zhye .ye {
		float: right;
		padding-right: 0.8rem;
		margin-right: 0.5rem;
		color: #FDB900;
		background-image: url(../../img/dating/bean.png);
		background-repeat: no-repeat;
		background-size: 0.5rem;
		background-position: right;
	}
	
	.jwdj {
		display: block;
		height: 1.88rem;
		line-height: 1.88rem;
	}
	.jwdj .level{
		margin-right: 0.7rem;
	}
	.jwdj .wrap>p {
		display: inline-block;
		vertical-align: top;
	}
	
	.jwdj .wrap>p img {
		vertical-align: middle;
		height: 0.6rem;
	}
	
	.jwdj .nobWrap{
		position: relative;
		display: inline-block;
		width: 6.4rem;
		height: 0.4rem;
		background: #A0A0A0;
		border-radius: 0.2rem;
		text-align: center;
		line-height: 0.4rem;
		color: #fff;
	}
	
	.jwdj .nobWrap i {
		position: absolute;
		left: 0;
		display: inline-block;
		height: 0.4rem;
		background: url(../../img/dating/progress.png);
		border-radius: 0.2rem;
	}
	
	.jwdj .nobWrap b {
		position: relative;
		z-index: 10;
		font-size: 0.36rem;
	}
	
	li.logout {
		/*margin-top: 2.4rem;*/
	}
	/* 登陆码整行样式（恢复原有高度） */
	.authCode-item {
	height: 2rem; /* 和其他funcList li高度完全一致 */
	padding: 0 0.72rem;
	}

	/* 标签+滑动容器外层 */
	.authCode-wrap {
	display: flex;
	align-items: center;
	height: 2rem; /* 匹配原有功能项高度 */
	width: 100%;
	}

	/* 登陆码标签 */
	.authCode-label {
	font-size: 0.56rem;
	color: #666;
	width: 2.4rem;
	line-height: 2rem;
	}

	/* 滑动容器（核心：恢复高度+横向滑动） */
	.authCode-scroll {
	flex: 1;
	overflow-x: auto;
	overflow-y: hidden;
	-ms-overflow-style: none;
	scrollbar-width: none;
	padding: 0 0.4rem;
	background-color: #f5f5f5;
	border-radius: 0.3rem;
	/* 恢复高度：和原有功能项内元素匹配 */
	height: 1.2rem;
	display: flex;
	align-items: center;
	}

	/* 隐藏滚动条 */
	.authCode-scroll::-webkit-scrollbar {
	display: none;
	}

	/* 登陆码文本（可手动选中复制） */
	.authCode-text {
	font-size: 0.58rem;
	font-family: "Menlo", "Consolas", monospace; /* 等宽字体，选中文本更易读 */
	color: #333;
	white-space: nowrap;
	line-height: 1.2rem;
	/* 关键：允许文本被选中（移动端手动复制必备） */
	user-select: text;
	-webkit-user-select: text; /* 兼容iOS/Android */
	}
	li.logout a {
		display: block;
		line-height: 1.88rem;
		font-size: 0.56rem;
		color: #afafaf;
	}
	.pop{
		width:11.12rem;
		height: 4.8rem;
		position: absolute;
		top: 50%;
		left: 50%;
		border: 1px solid #D5D5D3;
		margin: -2.9rem 0 0 -5.5rem;
		padding-top: 1.5rem;
		background: #FFF;
		border-radius: 0.4rem;
		text-align: center;
		box-shadow: 0 0 15px #F3E8EC;
		z-index: 10;
	}
	.pop p{
		font-size: 0.56rem;
		color: #666;
	}
	.pop button{
		width: 6rem;
		height: 1.2rem;
		background: linear-gradient(to right,#FF7E6E,#FD2092);
		border-radius: 0.6rem;
		border: none;
		margin-top: 1rem;
		color: #fff;
	}
	.pop i{
		position: absolute;
		top: 0;
		right: 0.4rem;
		font-size: 0.84rem;
		color: #666;
	}
</style>


// WEBPACK FOOTER //
// center.vue?19ac1b10